import Vue from 'vue';
import VMdDateRangePicker from 'v-md-date-range-picker';
import { MonthPicker } from 'vue-month-picker';
import Modal from '@burhanahmeed/vue-modal-2';
import vuetify from '@/plugins/vuetify';
import VueCompositionAPI from '@vue/composition-api';
import JsonExcel from 'vue-json-excel';

//import 'v-md-date-range-picker/dist/v-md-date-range-picker.css';
import '../src/assets/css/styles.scss';

import App from './App';
import router from './router';
import store from './store';


Vue.config.productionTip = false;

Vue.use(VMdDateRangePicker);
Vue.use(MonthPicker);
Vue.use(Modal);
Vue.use(VueCompositionAPI)
Vue.component('downloadExcel', JsonExcel);


export default new Vue({
  router,
  store,
  vuetify,
  el: '#app',
  template: '<App/>',
  components: { App },
});



// WEBPACK FOOTER //
// ./src/main.js